import { BillingService } from '@services/billing.service'
import { EntitlementName } from '@app/domain/Entitlement'
import { Injectable, InjectionToken } from '@angular/core'
import { Observable, catchError, map, of, startWith } from 'rxjs'

export type BillingEntitlementState = 'unlocked' | 'loading' | 'locked'

export interface BillingEntitlementStateSource {
    readonly billingEntitlementState$: Observable<BillingEntitlementState>
}

export const BILLING_ENTITLEMENT_STATE_SOURCE = new InjectionToken<BillingEntitlementStateSource>(
    'BILLING_ENTITLEMENT_STATE_SOURCE'
)

@Injectable({ providedIn: 'root' })
export class BillingEntitlementStateService {

    constructor(private billingService: BillingService) {}

    getState$(
        entitlementName: EntitlementName | null,
        ...currentUsage: [] | [number | null]
    ): Observable<BillingEntitlementState> {
        if (entitlementName === null) {
            return of('unlocked')
        }

        return this.billingService.getCachedBillingDetails()
            .pipe(
                map(billingDetails => {
                    const available = currentUsage.length === 0
                        ? billingDetails.hasEntitlement(entitlementName)
                        : billingDetails.hasEntitlementCapacity(entitlementName, currentUsage[0])
                    return available ? 'unlocked' : 'locked'
                }),
                catchError(() => of<BillingEntitlementState>('locked')),
                startWith<BillingEntitlementState>('loading')
            )
    }
}
